import { useState, useEffect } from "react";
import { Modal } from "semantic-ui-react";
import { RegisterForm, LoginForm, RecoverForm } from "../../../components/Admin/Auth";
import { EcosystemPanel } from "./EcosystemPanel";
import { BrujulaPanel } from "./BrujulaPanel";
import { EcosystemMobileHeader } from "./EcosystemMobileHeader";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { SocialLinks } from "./SocialLinks";
import "./Auth.scss";
import { useLanguage } from "../../../contexts";
import logoInk from "../../../assets/png/brand/logo-ink.png";

export function Auth() {
  const [registerOpen, setRegisterOpen] = useState(false);
  const [recoverOpen, setRecoverOpen] = useState(false);
  // Panel derecho de escritorio: alterna al azar entre el carrusel 3D y
  // la Brújula (radar) en cada visita — sorteado una sola vez por montaje
  // del componente, no en cada re-render. La Brújula no tiene versión
  // móvil propia (ver design_handoff_sustemia_login/README.md), así que
  // en mobile siempre se ve el carrusel vía EcosystemMobileHeader,
  // independientemente de este sorteo.
  const [useBrujula] = useState(() => Math.random() < 0.5);

  const { changeLanguage, translations, language } = useLanguage();
  const t = (key) => translations[key] || key;

  useEffect(() => {
    const idiomaNavegador = navigator.language || navigator.userLanguage || "";
    const idioma = idiomaNavegador.split("-")[0];
    changeLanguage(["es", "en", "pt"].includes(idioma) ? idioma : "es");
  }, []);

  return (
    <div className="login-page">
      <EcosystemMobileHeader t={t} language={language} changeLanguage={changeLanguage} />

      <div className="login-page__grid">
        <div className="login-panel">
          <img src={logoInk} alt="sustemia" className="login-panel__logo" />

          <div className="login-panel__center">
            <span className="login-panel__kicker">{t("login_kicker")}</span>

            {recoverOpen ? (
              <RecoverForm onBack={() => setRecoverOpen(false)} />
            ) : (
              <>
                <h1 className="login-panel__headline login-panel__headline--desktop">
                  {t("login_headline_line1")}
                  <br />
                  {t("login_headline_pre_highlight")}
                  <span className="login-panel__headline-highlight">
                    {t("login_headline_highlight")}
                  </span>
                  .
                </h1>
                <h1 className="login-panel__headline login-panel__headline--mobile">
                  {t("login_mobile_heading_pre")}
                  <span className="login-panel__headline-highlight">
                    {t("login_mobile_heading_highlight")}
                  </span>
                  .
                </h1>

                <p className="login-panel__subtitle">{t("login_subtitle")}</p>

                <LoginForm
                  onRegisterClick={() => setRegisterOpen(true)}
                  onRecoverClick={() => setRecoverOpen(true)}
                />
              </>
            )}
          </div>

          <footer className="login-panel__footer">
            <div className="login-panel__footer-row">
              <span className="login-panel__footer-tagline">
                {t("login_footer_tagline")}
              </span>
              <LanguageSwitcher
                language={language}
                changeLanguage={changeLanguage}
                className="login-panel__footer-lang"
              />
            </div>
            <SocialLinks className="login-panel__footer-socials" />
          </footer>
        </div>

        {useBrujula ? (
          <BrujulaPanel t={t} language={language} />
        ) : (
          <EcosystemPanel t={t} language={language} />
        )}
      </div>

      {/* Register Modal */}
      <Modal
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        size="tiny"
        closeIcon
        className="auth-modal"
      >
        <Modal.Content>
          <RegisterForm />
        </Modal.Content>
      </Modal>
    </div>
  );
}
